import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { COLS } from "@/components/VideoGallery";
import { fileUrl } from "@/lib/api";

// Grid of photos: 2 columns on phones, 3-4 on tablets, and 4, 6 or 8 on desktop. A click opens a large popup you can page through.
export const PhotoGallery = ({ id, items, cols = 8 }) => {
  const [open, setOpen] = useState(-1);
  const list = (Array.isArray(items) ? items : []).filter((p) => p?.url);
  if (!list.length) return null;
  const n = list.length;
  const cur = list[open];
  const go = (d) => setOpen((x) => (x + d + n) % n);
  return (
    <>
      <ul data-testid={`photo-gallery-${id}`} data-cols={COLS[cols] ? cols : 8} className={`grid grid-cols-2 gap-x-4 gap-y-6 ${COLS[cols] || COLS[8]}`}>
        {list.map((p, i) => (
          <li key={p.id || i}>
            <button type="button" data-testid={`photo-gallery-${id}-item-${i}`} onClick={() => setOpen(i)} aria-label={`Open ${p.title || `photo ${i + 1}`}`} className="group block w-full text-left">
              <span className="block aspect-square w-full overflow-hidden rounded-2xl bg-[#131C2E]">
                <img src={fileUrl(p.url)} alt={p.title || ""} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </span>
              {p.title && <span data-testid={`photo-gallery-${id}-title-${i}`} className="mt-2 line-clamp-2 block font-ui text-sm text-[#F4EEE2]">{p.title}</span>}
            </button>
          </li>
        ))}
      </ul>
      <Dialog open={open >= 0} onOpenChange={(o) => !o && setOpen(-1)}>
        <DialogContent data-testid={`photo-gallery-${id}-lightbox`} className="w-[94vw] max-w-[1400px] border-0 bg-black p-0 sm:max-w-[1400px]">
          <DialogTitle className="sr-only">{cur?.title || "Photo"}</DialogTitle>
          {cur && (
            <div className="relative">
              <img src={fileUrl(cur.url)} alt={cur.title || ""} className="max-h-[82vh] w-full object-contain" />
              {n > 1 && (
                <>
                  <button type="button" data-testid={`photo-gallery-${id}-prev`} onClick={() => go(-1)} aria-label="Previous photo" className="absolute left-3 top-1/2 grid h-11 w-11 -translate-y-1/2 place-items-center rounded-full" style={{ backgroundColor: "rgba(255,255,255,0.88)", color: "#14213D" }}><ChevronLeft className="h-5 w-5" /></button>
                  <button type="button" data-testid={`photo-gallery-${id}-next`} onClick={() => go(1)} aria-label="Next photo" className="absolute right-3 top-1/2 grid h-11 w-11 -translate-y-1/2 place-items-center rounded-full" style={{ backgroundColor: "rgba(255,255,255,0.88)", color: "#14213D" }}><ChevronRight className="h-5 w-5" /></button>
                </>
              )}
              <p className="px-5 py-3 font-ui text-sm" style={{ color: "#FFFFFF" }}>{cur.title ? <b>{cur.title}</b> : null}<span style={{ color: "#D1D5DB" }}>{cur.title ? " · " : ""}{open + 1} of {n}</span></p>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
